import {
  SET_SEARCH_LIST_PAGE_TOTAL,
  SET_SEARCH_LIST,
  SET_SEARCH_SORT,
  SET_SEARCH_LIST_EXPEND,
  SET_SEARCH_LIST_PACK_UP,
  SET_SEARCH_TASK_ID,
} from './mutation-types'
import api from '@/api'

const state = {
  taskSearch: {
    list: [],
    listCurrentPage: 1,
    listPageTotal: 0,
    listPageSize: 50,
    query: {
      taskId: null,
    },
    sort: {},
  },
}
const mutations = {
  [SET_SEARCH_LIST] (state, payload) {
    state.taskSearch.list = payload
  },
  [SET_SEARCH_SORT] (state, payload) {
    state.taskSearch.sort = payload
  },
  [SET_SEARCH_LIST_PAGE_TOTAL] (state, payload) {
    state.taskSearch.listPageTotal = payload
  },
  [SET_SEARCH_LIST_EXPEND] (state, {index, list}) {
    state.taskSearch.list[index].isExpand = true
    state.taskSearch.list.splice(index + 1, 0, ...list)
  },
  [SET_SEARCH_LIST_PACK_UP] (state, {index, length}) {
    state.taskSearch.list[index].isExpand = false
    state.taskSearch.list.splice(index + 1, length)
  },
  [SET_SEARCH_TASK_ID] (state, payload) {
    state.taskSearch.query.taskId = Number(payload)
  },
}
const actions = {
  // 运行的渲染作业列表
  async getTaskSearchList ({commit, state}) {
    try {
      let query = {
        ...state.taskSearch.sort,
        ...state.taskSearch.query,
      }
      const {data} = await api.taskApi.getGlobalSearchList(query)
      let list = data === null ? [] : data
      commit(SET_SEARCH_LIST, list)
    } catch (error) {
      console.log(error)
    }
  },
  setSearchTaskId ({commit}, payload) {
    commit(SET_SEARCH_TASK_ID, payload)
  },
  // 作业排序
  changeSearchSort ({commit, dispatch}, payload) {
    commit(SET_SEARCH_SORT, payload)
    dispatch('changeSearchListPage', {currentPage: 1})
  },
  // 展开子任务
  expandList ({commit}, {index, list}) {
    commit(SET_SEARCH_LIST_EXPEND, {index, list})
  },
  // 收起子任务
  packUpList ({commit}, {index, length}) {
    commit(SET_SEARCH_LIST_PACK_UP, {index, length})
  },
  // 重置排序
  resetSort ({dispatch}) {
    dispatch('changeSearchSort', {})
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
